import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    interviewId: null,
    interviewKey: null,
    accessToken: null,
    currentQuestionId: null,
    questionCount: 0,
    followupQuestions: [],
    timestamp: null,
    questions: []
}

export const UserSlice = createSlice({
    name: 'User',
    initialState,
    reducers: {
        setInterviewId: (state, action) => {
            state.interviewId = action.payload;
            state.timestamp = new Date().getTime();
        },
        setInterviewKey: (state, action) => {
            state.interviewKey = action.payload;
        },
        setAccessToken: (state, action) => {
            state.accessToken = action.payload;
        },
        setCurrentQuestionId: (state, action) => {
            state.currentQuestionId = action.payload;
        },
        setQuestionCount: (state, action) => {
            if (action.payload.isNewInterview) {
                state.questionCount = 0;
            } else if (state.currentQuestionId != action.payload || state.questionCount == 0) {
                state.questionCount = state.questionCount + 1;
            }
        },
        setFollowupQuestions: (state, action) => {
            console.log("Reducer payload:", action.payload);

            if (action.payload.is_followup_required) {
                state.followupQuestions.push({
                    question: action.payload.question,
                    answer: action.payload.answer
                });
            } else {
                state.followupQuestions = [];
            }
        },
        setQuestions: (state, action) => {
            state.questions.push(action.payload);
        },

        resetUserStateAfterExpiry: (state) => {
            const now = new Date().getTime();
            const THREE_HOUR = 3 * 60 * 60 * 1000;

            if (state.timestamp && now - state.timestamp > THREE_HOUR) {
                state.interviewId = null;
                state.interviewKey = null;
                state.accessToken = null;
                state.currentQuestionId = null;
                state.questionCount = 0;
                state.followupQuestions = [];
                state.timestamp = null;
            }
        },
        resetUserState: (state) => {
            Object.assign(state, initialState); // resets all to initialState
        },
    },
})

// Action creators are generated for each case reducer function
export const { setInterviewId, setAccessToken, setCurrentQuestionId, setQuestions, setQuestionCount, setFollowupQuestions, setInterviewKey, resetUserStateAfterExpiry, resetUserState } = UserSlice.actions

export default UserSlice.reducer